export const CONTENT_WORD = 'contenu';
export const ADD_ONE_CONTENT_TITLE = `Ajouter un ${CONTENT_WORD} ONE`;
export const SELECTED_WORD = 'sélectionné';
